import React, { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import { RefreshCw } from 'lucide-react';

// Shows "Actualizado hace X" using a timestamp (ms). Re-renders itself every 15s
// so the relative label stays fresh. Optionally renders an "Actualizar" button
// (pass onRefresh). Used on screens that no longer auto-refresh continuously.
export const LastUpdated = ({ timestamp, onRefresh, refreshing = false, className = '', label = 'Actualizar' }) => {
  const [, setTick] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setTick((t) => t + 1), 15000);
    return () => clearInterval(id);
  }, []);

  const text = () => {
    if (!timestamp) return 'Sin actualizar aún';
    const secs = Math.floor((Date.now() - timestamp) / 1000);
    if (secs < 10) return 'Actualizado hace un momento';
    if (secs < 60) return `Actualizado hace ${secs} s`;
    const mins = Math.floor(secs / 60);
    if (mins < 60) return `Actualizado hace ${mins} min`;
    const hrs = Math.floor(mins / 60);
    if (hrs < 24) return `Actualizado hace ${hrs} h`;
    const days = Math.floor(hrs / 24);
    return `Actualizado hace ${days} d`;
  };

  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="last-updated">
      <span className="text-xs text-slate-500 whitespace-nowrap" data-testid="last-updated-label">{text()}</span>
      {onRefresh && (
        <Button
          size="sm"
          variant="outline"
          onClick={onRefresh}
          disabled={refreshing}
          data-testid="last-updated-refresh-btn"
          className="h-7 px-2 text-xs border-slate-300 text-slate-700 hover:bg-slate-100"
          title="Actualizar ahora"
        >
          <RefreshCw className={`w-3.5 h-3.5 mr-1 ${refreshing ? 'animate-spin' : ''}`} />
          {label}
        </Button>
      )}
    </div>
  );
};

export default LastUpdated;
